import { Button } from 'react-bootstrap';
import { useGlobalContext } from '../context';

const Units = () => {
  const {
    setLessonState,
    lessonState,
    userInfo,
    setUserInfo,
    setScore,
    setData,
  } = useGlobalContext();

  // console.log('from units' + lessonState);

  const buttonsData = [];
  for (let i = 1; i < 36; i++) {
    buttonsData.push(i.toString());
  }

  const stateChangeHandler = (e, parameter) => {
    setData(null);

    if (localStorage.getItem('lessons')) {
      localStorage.removeItem('lessons');
    }

    localStorage.setItem('lessons', JSON.stringify(parameter));
    if (localStorage.getItem('score')) {
      localStorage.removeItem('score');
    }
    localStorage.setItem('score', JSON.stringify(0));
    setLessonState(parameter);
    setScore(0);

    if (userInfo) {
      setUserInfo((prevInfos) => {
        return { ...prevInfos, lessons: parameter, score: 0 };
      });
      localStorage.removeItem('userInfo');
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
  };

  return (
    <ul className="vertical-nav ">
      <li className="list-group-item">
        <Button
          variant={lessonState === 0 ? 'primary' : 'info'}
          className="btn-100"
          onClick={(e) => stateChangeHandler(e, 0)}
        >
          All{' '}
        </Button>{' '}
      </li>{' '}
      {buttonsData.map((item) => {
        // console.log(typeof item, typeof lessonState);
        return (
          <li className="list-group-item" key={item}>
            <Button
              onClick={(e) => stateChangeHandler(e, item)}
              variant={lessonState.toString() === item ? 'primary' : 'info'}
              className="btn-100 units"
            >
              Lesson {item}
            </Button>
          </li>
        );
      })}
    </ul>
  );
};

export default Units;
